<template>
    <main role="main">

        <router-view :key="$route.fullPath" />

    </main>
</template>

<script>

export default {

}
</script>
